/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import UUID from '@ax2/common/model/UUID';
import { ParticipantDefinedFieldData } from './ParticipantDefinedOption';
import Dropdown from '@ax2/common/components/Dropdown';
import _ from 'lodash';
import styles from '../../styles/components/answers/Ranking.module.css';
import removeIcon from '../../assets/remove_red.svg';

export interface DropdownRankOption {
  id: UUID;
  title: string;
  order?: number | null;
}
export type DropdownMenuParticipantDefinedOption = ParticipantDefinedFieldData;

export interface DropdownRankData {
  options: (DropdownRankOption | DropdownMenuParticipantDefinedOption)[];
  preselected?: any[];
  onCompletion: (id: UUID, order: number, index: number) => void;
  key?: string;
  onClear: (order: number) => void;
}

function getOptionText(
  opt: DropdownRankOption | DropdownMenuParticipantDefinedOption
) {
  return 'title' in opt ? opt.title : 'Other';
}

export const Ranking: React.FC<DropdownRankData> = data => {
  const options = data.options.map(option => ({
    title: getOptionText(option),
    value: option.id,
  }));

  return (
    <div className={styles.dropdownWrapper}>
      {options.map((_, i) => {
        return (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <span className={styles.numberIcon}>{i + 1}</span>
            <Dropdown
              value={
                data.preselected &&
                !!data.preselected[i] &&
                data.preselected[i].id
              }
              options={options}
              onChange={id =>
                data.onCompletion(id, i, options.findIndex(d => d.value === id))
              }
              optDisabled={
                data.preselected &&
                data.preselected.map(sel =>
                  sel !== undefined ? sel.id : undefined
                )
              }
            />
            <span className={styles.removeIcon} onClick={() => data.onClear(i)}>
              <img src={removeIcon} alt="remove" />
            </span>
          </div>
        );
      })}
    </div>
  );
};
